/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BidirectionalActionType,
  CreateHospitalMessageSync200Response,
  FindAllDisabledIntegrations200Response,
  FindAllHospitalMessagesSync200Response,
  GetBiDirectionalConfig200Response,
  HospitalMessage,
} from '../models/index';
import {
    BidirectionalActionTypeFromJSON,
    BidirectionalActionTypeToJSON,
    CreateHospitalMessageSync200ResponseFromJSON,
    CreateHospitalMessageSync200ResponseToJSON,
    FindAllDisabledIntegrations200ResponseFromJSON,
    FindAllDisabledIntegrations200ResponseToJSON,
    FindAllHospitalMessagesSync200ResponseFromJSON,
    FindAllHospitalMessagesSync200ResponseToJSON,
    GetBiDirectionalConfig200ResponseFromJSON,
    GetBiDirectionalConfig200ResponseToJSON,
    HospitalMessageFromJSON,
    HospitalMessageToJSON,
} from '../models/index';

export interface CreateHospitalMessageSyncRequest {
    leadId: string;
    hospitalMessage: HospitalMessage;
}

export interface FindAllDisabledIntegrationsRequest {
    facilityId?: string;
}

export interface FindAllHospitalMessagesSyncRequest {
    leadId: string;
}

export interface GetBiDirectionalConfigRequest {
    connector: GetBiDirectionalConfigConnectorEnum;
    action: BidirectionalActionType;
    facilityId: string;
    facilityType?: GetBiDirectionalConfigFacilityTypeEnum;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create a hospital message synchronously
     * Create a hospital message synchronously
     */
    async createHospitalMessageSyncRaw(requestParameters: CreateHospitalMessageSyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateHospitalMessageSync200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createHospitalMessageSync.');
        }

        if (requestParameters.hospitalMessage === null || requestParameters.hospitalMessage === undefined) {
            throw new runtime.RequiredError('hospitalMessage','Required parameter requestParameters.hospitalMessage was null or undefined when calling createHospitalMessageSync.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/hospital-messages/sync`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HospitalMessageToJSON(requestParameters.hospitalMessage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateHospitalMessageSync200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a hospital message synchronously
     * Create a hospital message synchronously
     */
    async createHospitalMessageSync(requestParameters: CreateHospitalMessageSyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateHospitalMessageSync200Response> {
        const response = await this.createHospitalMessageSyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all temporarily disabled integrations for an organization and optionally a specific facility
     * Get disabled integrations
     */
    async findAllDisabledIntegrationsRaw(requestParameters: FindAllDisabledIntegrationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllDisabledIntegrations200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integrations/disabled`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllDisabledIntegrations200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all temporarily disabled integrations for an organization and optionally a specific facility
     * Get disabled integrations
     */
    async findAllDisabledIntegrations(requestParameters: FindAllDisabledIntegrationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllDisabledIntegrations200Response> {
        const response = await this.findAllDisabledIntegrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all hospital messages for a lead synchronously
     * Get all hospital messages for a lead synchronously
     */
    async findAllHospitalMessagesSyncRaw(requestParameters: FindAllHospitalMessagesSyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllHospitalMessagesSync200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findAllHospitalMessagesSync.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/hospital-messages/sync`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllHospitalMessagesSync200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all hospital messages for a lead synchronously
     * Get all hospital messages for a lead synchronously
     */
    async findAllHospitalMessagesSync(requestParameters: FindAllHospitalMessagesSyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllHospitalMessagesSync200Response> {
        const response = await this.findAllHospitalMessagesSyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bidirectional config
     * Get bidirectional config
     */
    async getBiDirectionalConfigRaw(requestParameters: GetBiDirectionalConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBiDirectionalConfig200Response>> {
        if (requestParameters.connector === null || requestParameters.connector === undefined) {
            throw new runtime.RequiredError('connector','Required parameter requestParameters.connector was null or undefined when calling getBiDirectionalConfig.');
        }

        if (requestParameters.action === null || requestParameters.action === undefined) {
            throw new runtime.RequiredError('action','Required parameter requestParameters.action was null or undefined when calling getBiDirectionalConfig.');
        }

        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getBiDirectionalConfig.');
        }

        const queryParameters: any = {};

        if (requestParameters.connector !== undefined) {
            queryParameters['connector'] = requestParameters.connector;
        }

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.facilityType !== undefined) {
            queryParameters['facility_type'] = requestParameters.facilityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integrations/bidirectional-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBiDirectionalConfig200ResponseFromJSON(jsonValue));
    }

    /**
     * Get bidirectional config
     * Get bidirectional config
     */
    async getBiDirectionalConfig(requestParameters: GetBiDirectionalConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBiDirectionalConfig200Response> {
        const response = await this.getBiDirectionalConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetBiDirectionalConfigConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next'
} as const;
export type GetBiDirectionalConfigConnectorEnum = typeof GetBiDirectionalConfigConnectorEnum[keyof typeof GetBiDirectionalConfigConnectorEnum];
/**
 * @export
 */
export const GetBiDirectionalConfigFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL'
} as const;
export type GetBiDirectionalConfigFacilityTypeEnum = typeof GetBiDirectionalConfigFacilityTypeEnum[keyof typeof GetBiDirectionalConfigFacilityTypeEnum];
